var React = require('react');

function IconSort (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1523.971 -659)"},React.createElement("g",{"transform":"translate(5)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(1518.971 659)","fill":"none","key":0}),React.createElement("line",{"x2":"14","transform":"translate(1522.92 670)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1}),React.createElement("line",{"x2":"20","transform":"translate(1519.92 674)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":2}),React.createElement("line",{"x2":"8","transform":"translate(1525.92 666)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":3})])));
}

IconSort.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconSort;

IconSort.default = IconSort;
